import { z } from 'zod';
/** cuid-ish id — every PK in the schema. */
export const idSchema = z.string().min(1).max(64);
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
export const sortSchema = z.object({
    sortBy: z.string().max(64).optional(),
    sortDir: z.enum(['asc', 'desc']).default('desc'),
});
export const idParamSchema = z.object({ id: idSchema });
/** Pakistani mobile number, stored normalized as +92XXXXXXXXXX. */
export const phoneSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/[\s-]/g, ''))
    .refine((v) => /^(\+92|0)3\d{9}$/.test(v) || /^\+?\d{7,15}$/.test(v), {
    message: 'Enter a valid phone number (e.g. 03001234567)',
})
    .transform((v) => (v.startsWith('0') ? `+92${v.slice(1)}` : v.startsWith('+') ? v : `+${v}`));
export const cnicSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/-/g, ''))
    .refine((v) => /^\d{13}$/.test(v), { message: 'CNIC must be 13 digits' });
/** NTN is 7 digits, or a 13-digit CNIC used in its place (FBR accepts both). */
export const ntnSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/-/g, ''))
    .refine((v) => /^\d{7}$/.test(v) || /^\d{13}$/.test(v), {
    message: 'NTN must be 7 digits (or a 13-digit CNIC)',
});
/** Money is always integer paisa. Never accept a decimal from a client. */
export const paisaSchema = z.number().int();
export const positivePaisaSchema = z.number().int().min(0);
/** Quantity is always integer thousandths. */
export const qtyMilliSchema = z.number().int();
export const positiveQtyMilliSchema = z.number().int().min(1);
export const bpsSchema = z.number().int().min(0).max(100_000);
export const businessDateSchema = z.coerce.date();
export const dateRangeSchema = z
    .object({
    from: z.coerce.date(),
    to: z.coerce.date(),
})
    .refine((v) => v.from <= v.to, { message: '"from" must be on or before "to"' });
/** Report scope — every report supports all three (docs/SPEC.md §11). */
export const reportScopeSchema = z.object({
    scope: z.enum(['SHOP', 'SELECTED', 'ALL']).default('SHOP'),
    shopIds: z.array(idSchema).default([]),
});
/** Report tax basis — every money report supports all three. */
export const reportBasisSchema = z.enum(['GROSS', 'NET', 'TAX_ONLY']);
export const reportQuerySchema = dateRangeSchema
    .and(reportScopeSchema)
    .and(z.object({ basis: reportBasisSchema.optional() }));
export const exportFormatSchema = z.enum(['XLSX', 'CSV', 'PDF']);
//# sourceMappingURL=common.js.map